export const DEFAULT_ALLOWED_OPERATORS = ['<=', '>=', '==', '!=', '+', '-', '<', '>', 'and', 'or', 'not'];

export const DEFAULT_ALLOWED_VARIABLES = ['client_id'];

export const DATETIME_ALLOWED_VARIABLES = [
    'delivery_date',
    'delivery_end_date',
    'now',
    'today',
    'tomorrow',
    'yesterday',
];

export const DATETIME_ALLOWED_FUNCTIONS = [
    { name: 'date', slotCount: 1 },
    { name: 'time', slotCount: 1 },
    { name: 'business_days', slotCount: 1 },
    { name: 'days', slotCount: 1 },
    { name: 'weekday', slotCount: 1 },
];

export const BOOLEAN_CONSTANT_SUGGESTION = ['True', 'False', 'None'];
export const NUMBER_CONSTANT_SUGGESTION = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
export const DAY_CONSTANT_SUGGESTION = ['"Mon"', '"Tue"', '"Wed"', '"Thu"', '"Fri"'];
